module.exports = __webpack_public_path__ + "static/media/foodprint_app2.1091d90e.jpg";